import Article from '@/types/purchaseRequest/article'
import { BaseService } from './../../base'
export class ArticleService extends BaseService<Article>() {
    static get entity (): string {
        return 'article'
    }
    static get responseName (): string {
        return 'article'
    }
}